const result = (chip, toMatchWith) => {
    return null;
}

const Text = {
    result
}

export default Text;
